import { ParseNode } from '../../Parse/ParseNode';
import { Parser } from '../../Parse/Parser';
import { ExprComp } from '../ExprComp';
import { ExprForm } from '../ExprForm';
import { Generic } from './Generic';
export var Difference;
(function (Difference) {
    let Sources;
    (function (Sources) {
        Sources["Prev"] = "ZN($0) - LOOKUP(ZN($1),       -1)";
        Sources["Next"] = "ZN($0) - LOOKUP(ZN($1),        1)";
        Sources["First"] = "(ZN($0) - LOOKUP(ZN($1), FIRST()))";
        Sources["Last"] = "(ZN($0) - LOOKUP(ZN($1),  LAST()))";
    })(Sources = Difference.Sources || (Difference.Sources = {}));
    Difference.Patterns = [
        { relto: "PREV", parsed: Parser.parse("ZN($0) - LOOKUP(ZN($1),       -1)") },
        { relto: "NEXT", parsed: Parser.parse("ZN($0) - LOOKUP(ZN($1),        1)") },
        { relto: "FIRST", parsed: Parser.parse("(ZN($0) - LOOKUP(ZN($1), FIRST()))") },
        { relto: "LAST", parsed: Parser.parse("(ZN($0) - LOOKUP(ZN($1),  LAST()))") },
    ];
    function matches(candidateNode) {
        for (const pattern of Difference.Patterns) {
            if (pattern.parsed.type === "FAILURE") {
                return new Error(`Could not compile difference reference patterns`);
            }
            const comp = ExprComp.capture(pattern.parsed.root, candidateNode);
            if (comp == null) {
                return false;
            }
            if (comp instanceof Error) {
                return comp;
            }
            if (comp.type === "SUCCESS") {
                return true;
            }
        }
        return false;
    }
    Difference.matches = matches;
    function source(expr, relativeTo) {
        const target = ParseNode.toString(expr.root);
        switch (relativeTo) {
            case "PREV":
                return `ZN(${target}) - LOOKUP(ZN(${target}), -1)`;
            case "NEXT":
                return `ZN(${target}) - LOOKUP(ZN(${target}), 1)`;
            case "FIRST":
                return `(ZN(${target}) - LOOKUP(ZN(${target}), FIRST()))`;
            case "LAST":
                return `(ZN(${target}) - LOOKUP(ZN(${target}), LAST()))`;
        }
    }
    Difference.source = source;
    let Parsed;
    (function (Parsed) {
        function make(root) {
            for (const pattern of Difference.Patterns) {
                if (pattern.parsed.type === "FAILURE") {
                    continue;
                }
                const comp = ExprComp.capture(pattern.parsed.root, root);
                if (comp == null) {
                    continue;
                }
                if (comp instanceof Error) {
                    continue;
                }
                if (comp.type === "FAILURE") {
                    continue;
                }
                const { exprs, exprs: [expr], } = comp;
                const validForm = expr.form === ExprForm.Access ||
                    expr.form === ExprForm.Aggregate ||
                    expr.form === ExprForm.Generic;
                const length = exprs.length === 2;
                const equals = exprs.every((e) => e.name === expr.name);
                if (length && equals && validForm) {
                    const { relto } = pattern;
                    const state = "PARSED";
                    const form = ExprForm.Difference;
                    switch (expr.form) {
                        case ExprForm.Access: {
                            const { name } = expr;
                            return { state, root, form, expr, relto, name };
                        }
                        case ExprForm.Aggregate: {
                            const { name } = expr;
                            return { state, root, form, expr, relto, name };
                        }
                        case ExprForm.Generic: {
                            const name = ParseNode.toString(root);
                            return { state, root, form, expr, relto, name };
                        }
                    }
                }
            }
            return Generic.Parsed.make(root);
        }
        Parsed.make = make;
    })(Parsed = Difference.Parsed || (Difference.Parsed = {}));
    let Compiled;
    (function (Compiled) {
        function make(parsed, expr, stage, data) {
            const { name } = expr;
            return { ...parsed, expr, name, stage, data, state: "COMPILED" };
        }
        Compiled.make = make;
    })(Compiled = Difference.Compiled || (Difference.Compiled = {}));
})(Difference || (Difference = {}));
